import React from 'react';

export const AmenityCard = ({
  icon,
  title,
  description = "",
  hasImage = true
}) => {
  return (
    <div className="h-full">
      <div className="bg-[rgba(255,244,248,1)] flex flex-col rounded-xl h-full p-5 text-left shadow-sm">
        {hasImage && icon && (
          <img
            src={icon}
            alt={title}
            className="w-12 h-12 object-contain mb-4"
          />
        )}
        <h4 className="text-[#0B2549] font-sans text-base font-semibold mt-2">
          {title}
        </h4>
        <p className="text-[#6D7E94] font-sans text-xs mt-3">
          {description}
        </p>
      </div>
    </div>
  );
};
